<div class="managingfacility" *ngIf="inputConfig && inputConfig.length>0">
    <gen-dynamic-form
        [formConfig]="inputConfig"
        [editMode]="false"
        [formData] = "defaultValue"
        (formChange)="updateFacility($event.form)"
        [stayInFormMode]="true"
        [listenToDataChange]="listenToDataChange"
        [submitted]="widgetFormInstanceSubmitted"
        (validateChange)="updateValidate($event)"
    ></gen-dynamic-form>
</div>